
import { useState, useEffect } from 'react';
import { Loader } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  timeoutMs?: number;
  onTimeout?: () => void;
}

export const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 'md',
  timeoutMs = 20000, // 20 second default timeout
  onTimeout
}: LoadingSpinnerProps) => {
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  useEffect(() => {
    if (timeoutMs > 0) {
      const timer = setTimeout(() => {
        setShowTimeoutMessage(true);
        if (onTimeout) {
          onTimeout();
        }
      }, timeoutMs);

      return () => clearTimeout(timer);
    }
  }, [timeoutMs, onTimeout]);

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <Loader className={`${sizeClasses[size]} animate-spin text-primary`} />
      <div className="text-center">
        <p className="text-muted-foreground text-sm">{message}</p>
        {showTimeoutMessage && (
          <p className="text-yellow-600 text-xs mt-2">
            This is taking longer than expected. You may want to refresh the page.
          </p>
        )}
      </div>
    </div>
  );
};
